import { render, staticRenderFns } from "./CommentsView.vue?vue&type=template&id=24450c2a"
import script from "./CommentsView.vue?vue&type=script&lang=js"
export * from "./CommentsView.vue?vue&type=script&lang=js"
import style0 from "./CommentsView.vue?vue&type=style&index=0&id=24450c2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports